import React, { Component } from 'react';
import  {RedPageComponent} from './RedPageComponent.js';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { WidgetTemplateTg } from './WidgetTemplateTg';
import {WidgetTemplateVk} from './WidgetTemplateVk';
import {VkRedWidgetComponent} from './VkRedWidgetComponent';
import HelpBlockIcon from './HelpBlockIcon';



class RedWidget extends React.Component {

    state = {
       
      
        big_img_src : '',
        small_img_src : '',
        selected_file : null,
        prize : 'Спасибо за подписку! Ссылка на полезный материал [link]https://drive.google.com/file/d/1cVwT42N9_r8GuZmMWaKzommdYy4DBsYu/view?usp=sharing [/link]',
        header_text : 'Как во время кризиса заработать на криптовалютах? Топ 4 способа для каждого!',
        main_text : 'Наш телеграм канал специализируется на рынке криптовалют. За подписку на нас мы подарим полезный материал, в котором собрали и проанализировали разные способы заработать на криптовалютах прямо сейчас!',
        btnText : 'Подписаться',
        channel_name : '@moms',
        show_preview : false,
        timeout : 0 ,
        btn_color : 'yellow',
        btn_color_hex : 'yellow',
        btn_opacity : 0,
        show_color_picker_btn_color: false,
        bg1_color : 'yellow',
        bg1_color_hex: 'yellow',
        bg1_opacity : 1,
        show_color_picker_bg1_color: false,

        bg2_color : 'black',
        bg2_color_hex: 'black',
        bg2_opacity : 1,
        show_color_picker_bg2_color: false,

        btn_text_color : 'white',
        btn_text_color_hex: 'white',
        show_color_picker_btn_text_color: false,



        h1_color : 'black',
        h1_color_hex: 'black',
        show_color_picker_h1_color: false,

        h2_color : 'black',
        h2_color_hex: 'black',
        show_color_picker_h2_color: false,

        logo_color : 'black',
        logo_color_hex: 'black',
        show_color_picker_logo_color: false,

        frame_height: 300,
        frame_width: 571,
        frame_view_type: 'desktop',

        
        bg_mobile_color : 'white',
        bg_mobile_color_hex: 'white',
        bg_mobile_opacity : 1,
        show_color_picker_bg_mobile_color: false,
    }

    handleChangeComplete = (color, a) => {
        
        //const decimalToHex = (alpha: number) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

        //const hexCode = `${color.hex}${decimalToHex(color.rgb.a)}` 
        var hexCode = color.rgb
         
        if (a == 'btn') {
            this.setState({ btn_color: hexCode, btn_color_hex:color.hex })
        }
        if (a == 'bg1') {
            //alert(color.rgb.a)
            this.setState({ bg1_color: hexCode, bg1_color_hex: color.hex, bg1_opacity:color.rgb.a})
        }
        if (a == 'bg2') {
            //alert(color.rgb.a)
            this.setState({ bg2_color: hexCode, bg2_color_hex: color.hex, bg2_opacity:color.rgb.a})
        }
        if (a == 'btnText') {
            //alert(color.rgb.a)
            this.setState({ btn_text_color: hexCode, btn_text_color_hex: color.hex })
        }
        if (a == 'h1') {
            //alert(color.rgb.a)
            this.setState({ h1_color: hexCode, h1_color_hex: color.hex })
        }
        if (a == 'h2') {
            //alert(color.rgb.a)
            this.setState({ h2_color: hexCode, h2_color_hex: color.hex })
        }
        if (a == 'logo') {
            //alert(color.rgb.a)
            this.setState({ logo_color: hexCode, logo_color_hex: color.hex })
        }
        if (a == 'bgMobile') {
            //alert(color.rgb.a)
            this.setState({ 
                bg_mobile_opacity: color.rgb.a,
                bg_mobile_color: hexCode, 
                bg_mobile_color_hex: color.hex })
        }
       
      }

      showColorPicker = ( a) => {
        
        //const decimalToHex = (alpha: number) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

        //const hexCode = `${color.hex}${decimalToHex(color.rgb.a)}` 
        
         
        if (a == 'btn') {
            this.setState({show_color_picker_btn_color: true})
        }
        if (a == 'bg1') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_bg1_color: true })
        }
        if (a == 'bg2') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_bg2_color: true })
        }
        
        if (a == 'btnText') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_btn_text_color: true })
        }
        if (a == 'h1') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_h1_color: true })
        }
        if (a == 'h2') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_h2_color: true })
        }
        if (a == 'logo') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_logo_color: true })
        }
        if (a == 'bgMobile') {
            
            this.setState({ show_color_picker_bg_mobile_color: true })
        }
       
      }





     componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
      }
      
      rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      }
      
    componentWillMount() {
        this.setDefault()
        this.changeFrameView('desktop')
        document.addEventListener("mousedown", this.handleClickOutside);
        const cookies = new Cookies();
        
              
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetWidgetInfoByAlias?alias='+this.props.match.params.alias, {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    //projects = res.data.projects
                   
                    
                        console.log(res.data)
                        
                        this.setState( 
                            {  
                                big_img_src : res.data.big_img_src,
                                small_img_src : res.data.small_img_src,
                                selected_file : null,

                                prize : res.data.prize,
                                header_text : res.data.header_text,
                                main_text :  res.data.main_text,
                                btn_text : 'Подписаться',
                                channel_name : res.data.channel_name,
                                show_preview : false,
                                timeout : res.data.timeout,
                                btn_color_hex  : res.data.btn_color_hex,
                                bg1_color_hex  : res.data.bg1_color_hex,
                                bg1_opacity   : res.data.bg1_opacity,
                                bg2_color_hex  : res.data.bg2_color_hex,
                                bg2_opacity  : res.data.bg2_opacity,
                                bg_mobile_color : {
                                    r:res.data.bg_mobile_color_rgb.split('-')[0],
                                    g:res.data.bg_mobile_color_rgb.split('-')[1],
                                    b:res.data.bg_mobile_color_rgb.split('-')[2],
                                    a:res.data.bg_mobile_opacity
                                },
                                bg_mobile_color_hex : this.rgbToHex(
                                    parseInt(res.data.bg_mobile_color_rgb.split('-')[0]), 
                                    parseInt(res.data.bg_mobile_color_rgb.split('-')[1]),
                                    parseInt(res.data.bg_mobile_color_rgb.split('-')[2])),


                                bg_mobile_opacity : res.data.bg_mobile_opacity,

                                btn_text_color_hex  : res.data.btn_text_color_hex,
                                h1_color_hex  : res.data.h1_color_hex,
                                h2_color_hex : res.data.h2_color_hex,
                                logo_color_hex : res.data.logo_color_hex,

                             }
                         , () => {
                            console.log(this.state)
                        });
                   
                    

                })
                .catch(err => {
                    console.log(err);
                    

                })
        
        
        
        
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.colorPickerBtnColorRef && !this.colorPickerBtnColorRef.current.contains(event.target)) {
         
            this.setState({
            show_color_picker_btn_color: false
           })
        }
        if (this.colorPickerBg1ColorRef && !this.colorPickerBg1ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg1_color: false
           })
        }
        if (this.colorPickerBg2ColorRef && !this.colorPickerBg2ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg2_color: false
           })
        }
        
        
        if (this.colorPickerBtnTextColorRef && !this.colorPickerBtnTextColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_btn_text_color: false
           })
        }

        if (this.colorPickerH1ColorRef && !this.colorPickerH1ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_h1_color: false
           })
        }
        if (this.colorPickerH2ColorRef && !this.colorPickerH2ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_h2_color: false
           })
        }

        if (this.colorPickerLogoColorRef && !this.colorPickerLogoColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_logo_color: false
           })
        }

        if (this.colorPickerBgMobileColorRef && !this.colorPickerBgMobileColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg_mobile_color: false
           })
        }
      }

    constructor(props) {
        super(props);
       
        this.handleInputChange_smallImg = this.handleInputChange_smallImg.bind(this);
        this.handleInputChange_bigImg = this.handleInputChange_bigImg.bind(this);
        this.doSave = this.doSave.bind(this)
        this.updatePrize = this.updatePrize.bind(this)
        this.updateHeader = this.updateHeader.bind(this)
        this.updateMain = this.updateMain.bind(this)
        this.setShowPreview = this.setShowPreview.bind(this)
        this.updateTimeout = this.updateTimeout.bind(this)
        this.ClearPhotoMobile  = this.ClearPhotoMobile.bind(this)
        this.setDefault = this.setDefault.bind(this)
        this.changeFrameView = this.changeFrameView.bind(this)

        this.colorPickerBtnColorRef = React.createRef();
        this.colorPickerBg1ColorRef = React.createRef();
        this.colorPickerBg2ColorRef = React.createRef();
        this.colorPickerBtnTextColorRef = React.createRef();
        this.colorPickerH1ColorRef = React.createRef();
        this.colorPickerH2ColorRef = React.createRef();
        this.colorPickerLogoColorRef = React.createRef();
        this.colorPickerBgMobileColorRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
        // alert(this.props.match.params.alias)
        // alert(this.props.match.params.social)
    }
    setDefault() {
        this.setState({
            bg1_color : {r:7, g:103, b:244, a:0.04},
            bg1_color_hex: '#0767F4',
            bg1_opacity : 0.04,
            

            bg2_color : {r: 255, g: 255, b:255, a:1},
            bg2_color_hex: 'white',
            bg2_opacity : 1,
            

            bg_mobile_color : {r: 255, g: 255, b:255, a:1},
            bg_mobile_color_hex: 'white',
            bg_mobile_opacity : 1,

            btn_text_color : {r: 255, g: 255, b:255, a:1},
            btn_text_color_hex: 'white',
             

            btn_color : {r:7, g:103, b:244, a:0.04},
            btn_color_hex: '#0767F4',

            h1_color : {r: 0, g: 0, b:0},
            h1_color_hex: '#000000',
             

            h2_color : {r: 137, g: 137, b:137 , a:1},
            h2_color_hex: '#898989',
             

            logo_color : {r:7, g:103, b:244, a:0.04},
            logo_color_hex: '#0767F4',
        })
          
    }
    updateTimeout(e) {

        this.setState((prevState) => {
            return  {
                   ...prevState,
                   timeout : e.target.value
                   
               
               };
       }, () =>  {
           
       })


    }


    handleInputChange_bigImg(event) {
        
        this.setState({
            selected_file: event.target.files[0],
          }, () => {
            const data = new FormData() 
            data.append('file', this.state.selected_file)
            console.warn(this.state.selected_file);
            
            const cookies = new Cookies();
            
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
                 data, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    } // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                this.setState({
                    big_img_src: res.data.link
                  }, () => {})
            })
          })

    }


    handleInputChange_smallImg(event) {
        
        this.setState({
            selected_file: event.target.files[0],
          }, () => {
            const data = new FormData() 
            data.append('file', this.state.selected_file)
            console.warn(this.state.selected_file);
            
            const cookies = new Cookies();
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
                 data, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    }     // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                this.setState({
                    small_img_src: res.data.link
                  }, () => {})
            })
          })

    }


    updatePageName = (e) => {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    page_name : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    
    }

    updateChannelName = (e) => {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    channel_name : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    
    }
    
    
    CheckIntegration =(e) => {
        e.preventDefault()
        //alert('CheckIntegration')
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/CheckChannelIntegrated', {
            headers: {
                'Authorization': 'Bearer '+cookies.get('tgsubs_token')
            },
            params : {
                'chat_id' : this.state.channel_name
                
            }
        }).then((res) => {
            console.log(res.data)
            if (res.data.is_integrated) {
                this.props.handleClickFirstStage(e)
            }
            else {
                this.doShowErrorMsg('вы не настроили интеграцию')                                
           }
        })
        
    }

    CheckIntegration =(e) => {
        e.preventDefault()
        //alert('CheckIntegration')
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/CheckChannelIntegrated', {
            headers: {
                'Authorization': 'Bearer '+cookies.get('tgsubs_token')
            },
            params : {
                'chat_id' : this.state.channel_name
                
            }
        }).then((res) => {
            console.log(res.data)
            if (res.data.is_integrated) {
                this.handleClickFirstStage(e)
            }
            else {
                this.doShowErrorMsg('вы не настроили интеграцию')                                
           }
        })
        
    }

    ChooseTemplate = (e, tmp_id) => {
        

        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   tmp_id : tmp_id,
                    
               };
       }, () =>  {
           
       })

       this.handleClickSecondStage(e)

    }

    doShowErrorMsg ( msg) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   error_msg : msg,
                   show_error_msg : true
               };
       }, () =>  {
           
       })
        setTimeout(() => { 
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       error_msg : null,
                       show_error_msg : false
                   };
           }, () =>  {
               
           })

        }, 5000)
 
    }
    
    doSave(e) {
        e.preventDefault()
        //alert('CheckIntegration')
        const cookies = new Cookies();
        console.log(  JSON.stringify(this.state) )
       
        if (this.props.match.params.social == 'tg') {

            axios
            .post(process.env.REACT_APP_BACKEND_SERVER+'/UpdateTgWidget/', {
                'alias' : this.props.match.params.alias,
                'data' : JSON.stringify(this.state)
                
            }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                if (res.data.status == 'ok') {
                    window.location.reload()
                }
            })
            .catch(err => {
            console.log(err);
            })

        }
        else {
            axios
            .post(process.env.REACT_APP_BACKEND_SERVER+'/UpdateVkWidget/', {
                'alias' : this.props.match.params.alias,
                'data' : JSON.stringify(this.state)
                
            }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                if (res.data.status == 'ok') {
                    window.location.reload()
                }
            })
            .catch(err => {
            console.log(err);
            })
        }
        

          
    }

    updatePrize(e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    prize : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })


    }
    ClearPhotoMobile(e) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   small_img_src : null,
                   selected_file : null
               
               };
       }, () =>  {
           
       })
    }
    updateHeader (e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    header_text : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }

    updateMain(e) {
        const updatedInputValue = e.target.value;
        //alert(e.target.value)
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    main_text : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }

    
    setShowPreview(e, val) {

        this.setState((prevState) => {
            return  {
                   ...prevState,
                   show_preview : val,
                   
               
               };
       }, () =>  {
           
       })

    }

    transormLinks(x) {
        var res = x.match( /\[link\]\s*(.+?)\s*\[\/link\]/g )
        var link;
        if (res != null) {
            for (var i = 0; i < res.length; i++) {
                console.log( res[i] )
                link = res[i].replace('[link]', '').replace('[/link]', '')
                x = x.replace(res[i], '<a target="_blank" href="'+ link +'">'+ link+'</a>')
                
            }
        }
        
        return x
    }
    
    initialContent = () => {
        //286 571

        return (
          `<!DOCTYPE html>
          <html>
            <head>
              <link href="https://clientsaver.ru/static/css/main_with_viewport_v2.css" rel="stylesheet" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
            </head>
            <body>
              <div id="page" class="page"></div>
            </body>
          </html>`
        )
      }

      getIframeSize(a) {
        
        if (window.screen.width >= 3500) {
            if (a == 'mobile') {
                return [1100, 618]
            }
            else {
                return [788, 1500]
            }
        }

        if (window.screen.width >= 3000) {
            if (a == 'mobile') {
                return [1100, 618]
            }
            else {
                return [688, 1300]
            }
        }

        if (window.screen.width >= 2500) {
            if (a == 'mobile') {
                return [900, 518]
            }
            else {
                return [618, 1100]
            }
        }


        if (window.screen.width >= 2200) {
            if (a == 'mobile') {
                return [900, 518]
            }
            else {
                return [518, 900]
            }
        }


        if (window.screen.width >= 1750) {
            if (a == 'mobile') {
                return [700, 398]
            }
            else {
                return [398, 700]
            }
        }

        if (window.screen.width >= 1245) {
            if (a == 'mobile') {
                return [571, 300]
            }
            else {
                return [300, 571]
            }
        }

        if (window.screen.width >= 1000) {
            if (a == 'mobile') {
                return [500, 300]
            }
            else {
                return [200, 360]
            }
        }

        if (a == 'mobile') {
            return [500, 300]
        }
        else {
            return [200, 360]
        }
        

      }

      changeFrameView(a) {
        var d = this.getIframeSize(a)
        
        this.setState({
            frame_view_type : a,
            frame_height: d[0],
            frame_width: d[1]
        })
      }
      
    render() {
        return (
            <div>
                <div style={{marginTop: '5em'}} className="helpBlock"> <HelpBlockIcon /> 
                <span style={{marginLeft: '1.2em'}}>Если вы меняете время открытия, то надо переустановить новый код виджета на сайт. 
                    В иных случаях изменения появляются сразу.</span>
                </div> 

                
                               



                    <RedPageComponent
                    bg_mobile_opacity={this.state.bg_mobile_opacity} 
                 colorPickerBgMobileColorRef={this.colorPickerBgMobileColorRef}
                 show_color_picker_bg_mobile_color={this.state.show_color_picker_bg_mobile_color}
                 bg_mobile_color={this.state.bg_mobile_color}
                 bg_mobile_color_hex={this.state.bg_mobile_color_hex}
                
                 frame_view_type={this.state.frame_view_type}
                changeFrameView={this.changeFrameView}
                frame_height={this.state.frame_height}
                frame_width={this.state.frame_width}
                 showColorPicker={this.showColorPicker}
                 bg2_opacity={this.state.bg2_opacity} 
                 initialContent={this.initialContent}
                 bg2_color_hex={this.state.bg2_color_hex}
                 bg1_color_hex={this.state.bg1_color_hex}
                 bg1_opacity={this.state.bg1_opacity}
                 btn_color_hex={this.state.btn_color_hex}
                 big_img_src={this.state.big_img_src}
                 small_img_src={this.state.small_img_src}
                 refFirstStage={this.refFirstStage}
                 h1_color_hex={this.state.h1_color_hex}
                 h1_color={this.state.h1_color}
                 h2_color_hex={this.state.h2_color_hex}
                 header_text={this.state.header_text}
                 main_text={this.state.main_text}
                 logo_color_hex={this.state.logo_color_hex}
                 btn_text_color_hex={this.state.btn_text_color_hex}
                 setDefault={this.setDefault}
                 colorPickerBtnColorRef={this.colorPickerBtnColorRef}
                 show_color_picker_btn_color={this.state.show_color_picker_btn_color}
                 btn_color={this.state.btn_color}
                 handleChangeComplete={this.handleChangeComplete}
                 colorPickerBg1ColorRef={this.colorPickerBg1ColorRef}
                 show_color_picker_bg1_color={this.state.show_color_picker_bg1_color}
                 bg1_color={this.state.bg1_color}
                 
                 colorPickerBg2ColorRef={this.colorPickerBg2ColorRef}
                 show_color_picker_bg2_color={this.state.show_color_picker_bg2_color}
                 bg2_color={this.state.bg2_color}

                 colorPickerBtnTextColorRef={this.colorPickerBtnTextColorRef}
                 show_color_picker_btn_text_color = {this.state.show_color_picker_btn_text_color}
                 btn_text_color={this.state.btn_text_color}
                 

                 colorPickerH1ColorRef={this.colorPickerH1ColorRef}
                 show_color_picker_h1_color={this.state.show_color_picker_h1_color}

                 colorPickerH2ColorRef={this.colorPickerH2ColorRef}
                 show_color_picker_h2_color={this.state.show_color_picker_h2_color}
                 h2_color={this.state.h2_color}

                 colorPickerLogoColorRef={this.colorPickerLogoColorRef}
                 show_color_picker_logo_color={this.state.show_color_picker_logo_color}
                 logo_color={this.state.logo_color}





















                    ClearPhotoMobile={this.ClearPhotoMobile} 
                    timeout={this.state.timeout}
                    updateTimeout={this.updateTimeout}
                    
                    setShowPreview={this.setShowPreview}
                        doSave={this.doSave}
                        big_img_src={this.state.big_img_src}
                    small_img_src={this.state.small_img_src}
                    selected_file={this.state.selected_file}
                    prize={this.state.prize}
                    header_text={this.state.header_text}
                    main_text={this.state.main_text}
                    btnText={this.state.btnText}
                    updateMain={this.updateMain}
                    updateHeader={this.updateHeader}
                    updatePrize={this.updatePrize}
                    handleInputChange_bigImg={this.handleInputChange_bigImg}
                    handleInputChange_smallImg={this.handleInputChange_smallImg}
                        />





























                
               





            </div>
            
        )
        
        
    }
}

export default withRouter(RedWidget);